import React, { useEffect, useState } from 'react'
import './OrganizerPortal.css'
import { db } from '../../firebase'
import { collection, onSnapshot } from 'firebase/firestore'
import { getDownloadURL, getStorage, listAll, ref } from 'firebase/storage'
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
const OrganizerPortal = () => {
    const applicationsRef = collection(db, 'applications')
    const [applications, setApplications] = useState([])
    useEffect(() => {
        const getAllApplications = onSnapshot(applicationsRef, (querySnapshot) => {
            const items = []
            querySnapshot.forEach((doc) => {
                items.push(doc.data())
            })
            setApplications(items)
        })
        return () => {
            getAllApplications()
        }
        //eslint-disable-next-line
    }, [])
    const storage = getStorage()
    const downloadFiles = async (folderName) => {
        const storageRef = ref(storage, folderName);
        try {
            const files = await listAll(storageRef)
            const zip = new JSZip();
            await Promise.all(
                files.items.map(async (fileRef) => {
                    const url = await getDownloadURL(fileRef)
                    const response = await fetch(url)
                    const blob = await response.blob()
                    const fileName = fileRef.name;
                    zip.file(fileName, blob)
                })
            );
            const zipBlob = await zip.generateAsync({ type: 'blob' });
            saveAs(zipBlob, `${folderName}.zip`);
        } catch (error) {
            alert('Error downloading file');
        }
    }
    return (
        <div className='organizer-container'>
            <h1>Organizer Dashboard</h1>
            <div className='download-btn-container'>
                <button className='download-button' onClick={() => downloadFiles("paymentProof")}><i className="fa-solid fa-download" />Download all Payment proofs</button>
                <button className='download-button' onClick={() => downloadFiles("membershipCard")}><i className="fa-solid fa-download" />Download all Membership cards</button>
                <button className='download-button' onClick={() => downloadFiles("studentID")}><i className="fa-solid fa-download" />Download all Student ID cards</button>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Paper ID</th>
                        <th>Date of application</th>
                        <th>Name</th>
                        <th>Title of the paper</th>
                        <th>Phone number</th>
                        <th>Email</th>
                        <th>Transaction ID</th>
                        <th>Type of Author</th>
                        <th>Membership number</th>
                        <th>Membership card</th>
                        <th>Student ID card</th>
                        <th>Payment proof</th>
                    </tr>
                </thead>
                <tbody>
                    {applications && applications.map((item, index) => (
                        <tr key={index}>
                            <td>{item.paperId}</td>
                            <td>{item.applicationDate}</td>
                            <td>{item.name}</td>
                            <td>{item.title}</td>
                            <td>{item.phnNum}</td>
                            <td>{item.email}</td>
                            <td>{item.transactionId}</td>
                            <td>{item.typeOfAuthor}</td>
                            <td>{item.membershipNum ? item.membershipNum : "--"}</td>
                            <td>{item.membershipCard ? <a href={item.membershipCard} target='_blank' rel="noreferrer">Click here</a> : "--"} </td>
                            <td> {item.studentIdCard ? <a href={item.studentIdCard} target='_blank' rel="noreferrer">Click here</a> : "--"}  </td>
                            <td> <a href={item.paymentProof} target='_blank' rel="noreferrer">Click here</a> </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default OrganizerPortal